var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"edit"},[_c('div',{staticClass:"edit-column-c"},[_c('img',{attrs:{"src":require("@/assets/Group.png"),"alt":"","width":"100%"}}),_c('div',[_vm._v("对不起，此控件暂不支持编辑")])])])
}]

export { render, staticRenderFns }